import React from 'react'
import { Link } from 'react-router'
import './index.less'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'

export default class extends React.Component {
  componentDidMount() {
    setDocumentTitle('Terms of service')
  }

  render() {
    return (
      <div className="agreement">
        <br />
        <br />
        <h2>Notes</h2>
        <br />
        The operation entity of "Voca". (hereinafter referred to as "we"), hereby specifically reminds you (the
        user) to carefully read this User Agreement (hereinafter referred to as "the Agreement") and ensure that you
        fully understand the terms and conditions in this Agreement before you register as a user. Please read carefully
        and choose whether to accept or not accept this Agreement. Unless you accept all the terms in the Agreement, you
        have no right to register, log in or use the Services covered by the Agreement. Your registration, login, use
        and other behaviors will be deemed as acceptance of this agreement, and agree to be bound by the terms of this
        agreement.
        <br />
        <br />
        This Agreement stipulates the rights and obligations between App and users regarding App software Services
        (hereinafter referred to as the "Service")." User" refers to individuals who register, log in, or use the
        Service. After "Voca" modifies the terms of the agreement, if the user does not accept the modified terms, please
        immediately stop using the Services provided by "Voca". Users' continued use of the Services provided by "Voca"
        will be deemed to have accepted the modified agreement.
        <br />
        <br />
        I. Account registration in App
        <br />
        1. Users need to register a "Voca" account before using the Service.The "Voca" account shall be registered or
        bound with a third party or cell phone number, and users shall be requested to use third party or cell phone
        numbers that have not been connected to any "Voca" account and those third party or cell phone numbers that have
        not been blocked by App under the Agreement.
        <br />
        The user who logs in with snapchat must be older than 18.
        <br />
        <br />
        II. Service Content
        <br />
        1. Specific content of the Service is provided by “App” according to the actual situation, including but not
        limited to authorizing users to text messages, add friends, join groups, create rooms, have voice chat using
        their accounts, and other functions and Services. “App” may make changes to the Services provided and content of
        the Services provided by “App” may change from time to time;
        <br />
        2. The Services provided by "Voca" include free Services and paid Services. Users can purchase through the
        payment methods. The specific methods are: the user pays a certain amount of money through the payment methods
        provided by the "Voca" platform, to purchase the virtual currency in"Voca", Gold Coins. Afterwards, according to
        fee standards released by "Voca", gold coins can be used to buy what the user wants to use in the paid Service,
        in order to gain access to paid Services. For the paid Services, "Voca" will give users clear reminders before
        users’ using them. Users can only use paid Services under the condition that they confirm and agree to pay the
        fees according to the aforementioned payment methods and complete the payment according to the reminder. The
        completion of the payment is subject to the confirmation notice of "payment is completed" generated by the bank
        or the payment platform.
        <br />
        <br />
        III. User Personal Information Protection
        <br />
        1. "Voca" is committed to personal information protection together with users.
        <br />
        2. In the process of using App software and related Services, users may need to provide their personal
        information (including but not limited to their phone number, avatar information, device information, etc.) so
        that App can provide better Services and technical support to users. App will protect users' rights to browse,
        modify and delete relevant personal information and withdraw authorization adhere to regulations, and will use
        encryption technology, anonymization and other technical measures as well as security measures that are
        compatible with App software and related Services, to protect users' personal information.
        <br />
        3. For more information about user personal information protection, please refer to the Privacy Policy of "Voca"
        .<br />
        4.If you need to delete your user information, there are three ways to do so: <br />
        (1) Send us feedback on the login page through the following path: Feedback button on the login page>Feedback.
        Once we receive feedback, we will contact you <br />
        (2) Log in to your application and send us feedback through the following path: I>Feedback. Once we receive
        feedback, we will contact you <br />
        (3) Log in to your application and complete it autonomously through the following path: Me>Settings>Delete
        Account
        <br />
        <br />
        <br />
        IV. Content Regulation
        <br />
        1. Content mentioned in this article refers to any content released by users during the use of the Service,
        including but not limited to account picture, name, personal signature and other registration information, text
        message, voice chat content and related link pages, as well as other content generated by the use of account or
        generated during the Service.
        <br />
        2. Users shall not use App account or the Service to post the following contents that might interfere with daily
        operation of App or infringe upon the legitimate rights and interests of other users or third parties:
        <br />
        (1) Contents containing any sex or sexual implication;
        <br />
        (2) Contents of abuse, intimidation or threat;
        <br />
        (3) Contents that contains harassment, spam, malicious information and deceptive information;
        <br />
        (4) Contents that involves other users' privacy, personal information or data;
        <br />
        (5) Infringement of others' right of reputation, right of portrait, intellectual property, trade secrets and
        other legal rights;
        <br />
        (6)Contents that contains other information that interferes with the normal operation of the Service and
        infringes the legitimate rights and interests of other users or third parties.
        <br />
        <br />V Virtual Currency
        <br />
        1. App will issue virtual currency, namely gold coins, on App platform. Gold coins can be used to purchase App's
        value-added Services, including but not limited to virtual gifts. Apart from that, it cannot be used for any
        other purpose. Prices of value-added Services are measured in gold coins and the specific price information will
        be determined by "Voca" and displayed on the relevant Service page.
        <br />
        2, Before any top-ups, users have confirmed the account carefully and carefully chosen relevant operation
        options. If any recharge to a wrong account or any wrong selection on recharge types happens, because of user's
        entering wrong account information, improper operation or misunderstanding on the payment methods, "Voca" will
        not make any compensation.
        <br />
        3. Users confirm that, once the gold coins are recharged, they shall not be converted into any legal tender or
        be transferred to others under any circumstances. Except as expressly provided by laws and regulations, App will
        not provide refund after gold coins are recharged.
        <br />
        4. User confirms that diamonds can only be used to purchase various value-added Services on the "Voca" platform
        and shall not trade diamonds with third parties other than "Voca" or on any third party platform other than "Voca"
        under any circumstances; App shall not be liable for any loss caused to the user or to any third party due to
        its violation of the foregoing provisions. If App has any reason to suspect that the user's gold coins account
        or usage is cheating or abnormal, App will refuse the user to use gold coins for payment until it takes relevant
        blocking measures as agreed herein.
        <br />
        5. "Voca" has the right to set or modify transaction related matters from time to time, including but not limited
        to the trading limitation and the number of transactions, based on consideration of transaction security and
        other aspects. The user understands and confirms that the aforementioned setting or modification from "Voca" may
        cause some inconvenience to the user's trading, and the user has no objection to it.
        <br />
        6. User acknowledges that, unless expressly provided by laws and regulations or otherwise agreed herein, any
        paid Services purchased by User cannot be returned (i.e., returned for gold coins or legal tender) or exchanged
        for other Services for any reason.
        <br />
        7. Users shall be solely responsible for any loss or liability arising from App's failure to provide gold coin
        purchase Service or any mistake in providing the gold coin purchased Service due to users’ own reasons,
        including but not limited to:
        <br />
        (1) The user's App account is lost, banned or frozen;
        <br />
        (2) Property losses caused by users informing others of their passwords;
        <br />
        (3) Any loss or liability caused by the account of the third-party payment institution bound by the user;
        <br />
        (4) Property losses caused by other users' intentional behaviors or gross negligence or violation of laws and
        regulations.
        <br />
        8. App has the right to temporarily or permanently ban users' accounts if users violate national laws and
        regulations, this Agreement or other rules governing users on the Platform, when using the Services provided by
        App. The remaining gold coins in the user's account will be temporarily frozen or deducted from the account
        until the account is lifted (if any), and cannot be used to purchase virtual products or Services on the
        platform. At the same time, the cash value of the gold coins purchased by the user will not be returned.
        <br />
        VI. Account management
        <br />
        1. The ownership of the "Voca" account belongs to "Voca". After completing the application and registration, user
        can obtain the right to use the "Voca" account. The right to use belongs only the initial applicant and may not
        be given, lent, leased, transferred or sold.
        <br />
        2. Users can inquire, change, delete and cancel the personal data and registration information on the "Voca"
        account through the "My" page. However, it should be noted that the text and images stored in the system will
        also be deleted when the relevant information is deleted. This risk is borne by the user.
        <br />
        3. Users shall be responsible for the security of their registered account information and account password.
        Users shall be liable for account theft or password theft due to improper safekeeping. The user shall bear legal
        responsibility for the actions under the registered account and password. User agrees not to use another user's
        account or password under any circumstances. Users agree to notify App immediately if they suspect someone else
        is using their account or password.
        <br />
        4. Users shall abide by the terms of this Agreement and use the Service correctly and appropriately. If a user
        violates any terms of this Agreement, App has the right to interrupt or terminate the Service provided to the
        user's "Voca" account in breach according to this Agreement after notifying the user.
        <br />
        <br />
        VII. Intellectual Property Rights Declaration
        <br />
        1. The intellectual property rights of the contents provided by App in the Service (including but not limited to
        web pages, texts, pictures, audio, video, charts, etc.) are owned by App, except that users have legally
        acquired the intellectual property rights of the contents published by themselves before using the Service.
        <br />
        2. Unless otherwise specially stated, the copyright, patent and other intellectual property rights of the
        software used by App in providing the Service are owned by App.
        <br />
        3. The copyright or trademark right of the graphics, words or their composition involved by App in the Service,
        and other App logos and products and Service names (collectively, "App Logo") shall be owned by App. Without
        App's prior written consent, users shall not display, use or otherwise dispose of the App logo in any way, nor
        shall they indicate to others that they have the right to display, use or otherwise dispose of the App logo.
        <br />
        4. The aforementioned and any other intellectual property legally owned by "Voca" or the relevant advertisers are
        protected by law, and without the written permission of "Voca" or the relevant advertisers, users shall not use
        or create derivative works in any form.
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/voca-terms/index.js